module.exports = __webpack_public_path__ + "static/media/awards_18.a456ee76.jpg";